import { gql } from "@apollo/client";

export const CLEAR_OWNERSHIP_EXPIRY_COUNT = gql`
  mutation Clear_Ownership_Expiry_Count {
    clearAlertCountOfOwnership {
      message
      status
    }
  }
`;